import { SUBMIT, CLEAR, OVERWRITE_FORM } from './submit.actions';

const saveToLocal = (formState) => {
  // eslint-disable-next-line no-new
  new Promise(() => {
    localStorage.setItem(
      'form',
      JSON.stringify({
        ...formState,
      }),
    );
  });

  return formState;
};

export default function reducer(state = {
  activeWorkPlan: {
    sysId: '',
  },
  mapOptions: {
    showWorkPlanLicenses: false,
  },
}, action) {
  if (action.type === OVERWRITE_FORM) {
    return action.payload;
  }

  const splits = action.type.split('_');
  const adtProps = {};
  if (action.type.startsWith(CLEAR)) {
    // Clears all data for the form if not specifying a step ([splits[2])
    if (splits.length === 2) {
      return saveToLocal({
        ...state,
        [splits[1]]: action.payload,
      });
    }

    return saveToLocal({
      ...state,
      [splits[1]]: {
        ...state[splits[1]],
        [splits[2]]: undefined,
        ...adtProps,
      },
    });
  }

  if (!action.type.startsWith(SUBMIT)) return state;


  if (splits.length === 1) {
    return saveToLocal({
      ...state,
      ...action.payload,
    });
  }

  if (splits.length === 2) {
    return saveToLocal({
      ...state,
      [splits[1]]: {
        ...state[splits[1]],
        ...action.payload,
        ...adtProps,
      },
    });
  }

  if (splits.length > 2) {
    return saveToLocal({
      ...state,
      [splits[1]]: {
        ...state[splits[1]],
        [splits[2]]: {
          ...state[splits[1]][splits[2]],
          ...action.payload,
        },
        ...adtProps,
      },
    });
  }

  return state;
}
